module.exports = __webpack_public_path__ + "img/train1.530cd543.jpeg";